import { enqueueSnackbar } from 'notistack';

export function handleSubmitError(
  error,
  setFieldError,
  setCurrentStep,
  fieldStepMap,
) {
  // eslint-disable-next-line no-console
  console.error('handleSubmitError', error);
  if (error?.response?.data?.message == 'Validation error') {
    if (setFieldError) {
      const fieldsWithErrors = Object.entries(
        error.response.data.extra.fields,
      ).map(([field, errorMsg]) => {
        errorMsg = Array.isArray(errorMsg)
          ? [...errorMsg.map((subError) => ({ ...subError }))]
          : errorMsg;
        setFieldError(field, errorMsg);
        return field;
      });
      if (setCurrentStep && fieldStepMap) {
        const stepsWithErrors = Object.entries(fieldStepMap)
          .filter(([field, _step]) => {
            return fieldsWithErrors.includes(field);
          })
          .map(([_field, step]) => step)
          .sort((a, b) => a - b);
        const earliestStepWithError = stepsWithErrors[0];
        setCurrentStep((_currentStep) => earliestStepWithError);
      }
    }
    enqueueSnackbar('Corrija os campos indicados!', { variant: 'error' });
  } else if (error?.response?.data?.message) {
    enqueueSnackbar(error.response.data.message, { variant: 'error' });
  } else {
    enqueueSnackbar('Aconteceu algo de errado. Tente novamente!', {
      variant: 'error',
    });
  }
}
